export default "<app-user-list [screenStructure] = \"screenDescriptor\"></app-user-list>\n";